<template>
<div class="c-offline-notification">
  <span class="c-offline-notification__span">
    <offline-icon class="c-offline-notification__icon"></offline-icon>
    <p class="c-offline-notification__text">{{ $t(text) }}</p>
  </span>
  </div>
</template>

<script>
import OfflineIcon from '@/assets/svg/OfflineIcon'

export default {
  name: 'offline-notification',

  components: {
    'offline-icon': OfflineIcon
  },

  props: {
    text: {
      type: String,
      default: 'SINCE_YOU_ARE_OFFLINE'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_vars.scss';

.c-offline-notification {
  margin: auto;
  text-align: center;
  padding-top: 6em;
}
.c-offline-notification__span {
  cursor: auto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.4px;
  color: $blue;
  border: 3px solid $orange;
  padding: .7em 1.2em;
  white-space: normal;
  height: 100%;
  background: $white;
  border-radius: 2em;
  display: inline-block;
  margin: auto;
}
.c-offline-notification__icon {
  margin-right: 0.5em;
  vertical-align: middle;
}
.c-offline-notification__text {
  display: inline;
}

@media screen and (min-width: 480px) {
  .c-offline-notification__icon {
    width: 25px;
  }
}
</style>